import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {HomeComponent} from './components/home/home.component';
import {CalculatorComponent} from './components/calculator/calculator.component';
import {AssumptionsComponent} from './components/assumptions/assumptions.component';
import {ResultsComponent} from './components/results/results.component';
import {FaqComponent} from './components/faq/faq.component';
import {AboutComponent} from './components/about/about.component';
import {CalculatorIntroComponent} from './components/calculator-intro/calculator-intro.component';
import {ContactComponent} from './components/contact/contact.component';


const routes: Routes = [
  {path: 'home', component: HomeComponent},
  {path: 'sobre-el-proyecto', component: AboutComponent},
  {path: 'calculadora-intro', component: CalculatorIntroComponent},
  {path: 'calculadora', component: CalculatorComponent},
  {path: 'supuestos', component: AssumptionsComponent},
  {path: 'resultados', component: ResultsComponent},
  {path: 'faq', component: FaqComponent},
  {path: 'contacto', component: ContactComponent},
  {path: '**', redirectTo: 'home', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollOffset: [0, 0],
    scrollPositionRestoration: 'top'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
